<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">免费注册</h1>
              <p class="text-lead text-white">开启AI时代的量化交易之旅</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" >
          <b-card no-body class="bg-secondary border-0" style="margin-top:-30px">
            <!-- <b-card-header class="bg-transparent pb-5">
              <div class="text-muted text-center mt-2 mb-4"><small>Sign up with</small></div>
              <div class="text-center">
                <a href="#" class="btn btn-neutral btn-icon mr-4">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </b-card-header> -->
            <b-card-body class="px-lg-5 py-lg-5" >
              <!-- <div class="text-center text-muted mb-4">
                <small>Or sign up with credentials</small>
              </div> -->
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">

                   <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-email-83"
                              placeholder="请输入您的邮箱"
                              name="Email"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-hat-3"
                              placeholder="请输入您的昵称"
                              name="Name"
                              v-model="model.name">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="请输入您的密码"
                              type="password"
                              name="Password"
                              v-model="model.password">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="请再次输入您的密码"
                              type="password"
                              name="RePassword"
                              v-model="model.re_password">
                  </base-input>

                  <div class="text-muted">
                    <small v-if="error_tip != ''">
                      <span class="error_tip_font text-danger">{{error_tip}}</span>
                    </small>
                  </div>

                  <b-row class=" my-4">
                    <b-col cols="12">
                      <base-input >
                        <b-form-checkbox v-model="model.agree">
                          <span class="text-muted">我同意 <a href="#!">用户使用协议</a></span>
                        </b-form-checkbox>
                      </base-input>
                    </b-col>
                  </b-row>
                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4">注册账号</b-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import loginApi from "../../api/login";

  export default {
    name: 'register',
    data() {
      return {
        model: {
          name: '',
          email: '',
          password: '',
          re_password: '',
          agree: false
        },
        error_tip:"",
      }
    },
    methods: {
      isValidEmail(email) {
          // 正则表达式用于验证电子邮件格式
          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailRegex.test(email);
      },
      async onSubmit() {
        const {name,email,password,re_password,agree} = this.model;
        console.log("======",{name,email,password,re_password,agree})

        if(email == "" || email.trim() == "")
        {
          this.error_tip = "邮箱不能为空";
          return;
        }

        if(!this.isValidEmail(email))
        {
          this.error_tip = "请填写您的真实邮箱（用于登陆和密码找回）";
          return;
        }

        if(name == "" || name.trim() == "")
        {
          this.error_tip = "昵称不能为空";
          return;
        }
        if(password == "" || re_password == "")
        {
          this.error_tip = "密码不能为空";
          return;
        }
        if(password != re_password)
        {
          this.error_tip = "两次输入密码不一致，请检查";
          return;
        }
        if(!agree)
        {
          this.error_tip = "请同意用户使用协议"
          return
        }

        const data = await loginApi.doRegister({
          name: this.model.name,
          email: this.model.email,
          pwd: this.model.password,
        });

        if (data.code == 200) {
          const { user, token } = data.data;
          // console.log("==========注册成功",{user,token,data})
          this.error_tip = ""

          localStorage.setItem("authorization", token);
          localStorage.setItem("userInfo", JSON.stringify(user));
          this.$router.push("/AI");
        } else {
          const { err_msg } = data;
          this.error_tip = err_msg
        }

      }
    }

  };
</script>
<style>
.error_tip_font
{
  font-size: 16px;
}
</style>
